module.exports = __webpack_public_path__ + "img/row_drag.6e81d260.svg";